class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
        this.recommendedUrl = this.getAttribute('recommendedUrl');
        this.sectionId = this.getAttribute('section-id');
        this.productId = this.getAttribute('product-id');
        this.limit = this.getAttribute('limit');
        this.initialContentLoad = true;
        this.url = `${this.recommendedUrl}?section_id=${this.sectionId}&product_id=${this.productId}&limit=${this.limit}`;
    }

    removeSection() {
        const section = this.closest('section');
        if (section) section.remove();
    }

    async renderProducts() {
        try {
            const response = await fetch(this.url, { method: 'GET' });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const data = await response.text();
            const html = document.createElement('div');
            html.innerHTML = data;

            const recommendations = html.querySelector('product-recommendations');
            const loader = recommendations ? recommendations.querySelector('[recommendation-loader]') : null;

            if (recommendations && loader && loader.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
            } else {
                this.removeSection();
            }
        } catch (error) {
            console.warn('Product recommendations could not be loaded.', error);
            this.removeSection();
        }
    }

    connectedCallback() {
        if (!this.recommendedUrl || !this.sectionId || !this.productId) {
            this.removeSection();
            return;
        }

        const run = this.renderProducts.bind(this);
        if ('requestIdleCallback' in window) {
            window.requestIdleCallback(run, { timeout: 1000 });
        } else {
            window.setTimeout(run, 0);
        }
    }
}

if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
}
